import { Form, Input, DatePicker, Select, Upload, Avatar } from "antd";
import ImgCrop from 'antd-img-crop';
import LoadableButton from "../../../components/buttons/LoadableButton";
import Lock from "../../../assets/auth/Lock";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setloggedIn, setUserDetails } from "../../../store/Slices/userSlice";
import { AddBankDetailApi, ChangePasswordApi, ForgetOtp2FAApi, GetUserApi, LogoutApi, Request2faChangeApi, UpdateUserApi } from "../../../api/request/users";
import toast from "react-hot-toast";
import { GetAllCountryApi } from "../../../api/request/common";
import dayjs from "dayjs";
import { removeCookies } from "../../../services/Cookies";
import ModalComponent from "../../../components/modals/ModalComponent";
import { IpProvider } from "../../../services/IpProvider";
import BankDetails from "./components/BankDetails";

export default function UserProfile() {

  const [form] = Form.useForm();
  const [updateForm] = Form.useForm();
  const [formotp] = Form.useForm();
  const [bankForm] = Form.useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);

  const [user, setUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProfileUpdate, setIsLoadingProfileUpdate] = useState(false);
  const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [FormData, setFormData] = useState({ email: "" });
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [ipAddress, setIpAddress] = useState('');
  const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
    const stored = localStorage.getItem("verifyWithOpt");
    return stored ? JSON.parse(stored) : false;
  });
  const [isLoadingBankDetails, setIsLoadingBankDetails] = useState(false);

  const getUser = async () => {
    try {
      const { data } = await GetUserApi(userDetails?._id);
      setUser(data?.data);
      updateForm.setFieldsValue({
        FirstName: data?.data?.firstName,
        LastName: data?.data?.lastName,
        PhoneNo: data?.data?.phoneNo,
        ProfileImage: data?.data?.profileImage,
        DOB: data?.data?.dob ? dayjs(data?.data?.dob) : '',
        ExpAsIb: data?.data?.expAsIb,
        City: data?.data?.city,
      });
      dispatch(setUserDetails({ ...userDetails, profileImage: data?.data?.profileImage }));
    } catch (error) {
    }
  }

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    updateForm.setFieldsValue({ profileImage: newFileList });
    if (newFileList.length === 0) {
      updateForm.setFieldsValue({ profileImage: null });
    }
  }

  const updateUserProfile = async (values) => {
    const extractOriginFileObj = (fileArray) => fileArray && fileArray[0]?.originFileObj;
    try {
      setIsLoadingProfileUpdate(true);
      let apiHeader = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };
      let params = {
        ...values,
        UserId: userDetails?._id,
        DOB: values['DOB'] ? dayjs(values['DOB']).format('MM/DD/YYYY') : '',
      };
      if (values.profileImage && values.profileImage.length > 0) {
        params.ProfileImage = extractOriginFileObj(values.profileImage);
        delete params.profileImage;
      }
      const { data } = await UpdateUserApi({ ...params }, apiHeader);
      if (data?.success) {
        updateForm.resetFields();
        setFileList([]);
        toast.success(data?.message);
        getUser();
      }
      setIsLoadingProfileUpdate(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoadingProfileUpdate(false);
    }
  }

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(
          data?.data?.map((item) => ({
            ...item,
            value: item?.id,
            label: item?.countryName,
          }))
        );
      }
    } catch (error) { }
  };

  const filterOption = (input, option) => {
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  };

  const beforeUpload = (file) => {
    const isAllowedType =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    if (!isAllowedType) {
      toast.error("You can only upload JPG/JPEG/PNG files!");
      return Upload.LIST_IGNORE;
    }
    const isLt800K = file.size / 1024 < 800;
    if (!isLt800K) {
      toast.error("Image must be smaller than 800KB!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleSubmit = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    const params = {
      id: userDetails?._id,
      oldPassword,
      password: newPassword,
      confirmPassword,
    };
    try {
      setIsLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        logoutHandler();
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };

  const getIpAddress = async () => {
    try {
      const { data } = await IpProvider();
      setIpAddress(data?.ip);
    } catch (error) { }
  }

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi({ ipAddress });
      if (data?.success) {
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
    }
  };

  const open2FAHandle = async () => {
    setLoading(true);
    const success = await resendOTPHandler(!verifyWithOpt);
    setLoading(false);
    if (success) {
      setFormData({ otp: "" });
      setTimer(120);
      setIsOpen2FAModal(true);
    }
  };

  const resendOTPHandler = async (values) => {
    try {
      const { data } = await Request2faChangeApi(values);
      if (data?.success) {
        toast.success(data?.message);
        return true;
      }
    } catch (err) {
    }
    return false;
  };

  const handleSubmit2FA = async (values) => {
    const { otp } = values;
    if (!otp) {
      toast.error("OTP can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        userId: userDetails?._id,
        Otp: otp,
        isActiveFlag: !verifyWithOpt,
      };
      const { data } = await ForgetOtp2FAApi(params);
      if (data?.success) {
        toast.success(data?.message);
        const newValue = !verifyWithOpt;
        setVerifyWithOpt(newValue);
        localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
        formotp.resetFields();
        setIsOpen2FAModal(false);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "Something went wrong");
      setIsLoading(false);
    }
  };

  const onChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    setFormData({ ...FormData, otp: newValue });
  };
  const sharedProps = {
    onChange,
  };

  const formatTime = (timer) => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const handleBankSubmit = async (values) => {
    setIsLoadingBankDetails(true);
    try {
      const { data } = await AddBankDetailApi(values);
      if (data?.success) {
        toast.success(data?.message);
        bankForm.resetFields();
      }
    }
    catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save bank details.");
    }
    finally {
      setIsLoadingBankDetails(false);
    }
  };

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("verifyWithOpt"));
    if (stored !== null) {
      setVerifyWithOpt(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    getIpAddress();
    getUser();
    getContriens();
  }, []);

  return (
    <>
      <div className="md:p-6 p-4 border-2 border-light rounded-[10px] h-full">
        <Form
          form={updateForm}
          layout="vertical"
          autoComplete="off"
          onFinish={updateUserProfile}
        >
          <div className="flex items-center gap-4 mb-8">
            <Form.Item
              name="profileImage"
              valuePropName="fileList"
              className="mb-0"
            >
              <ImgCrop rotationSlider showGrid>
                <Upload
                  fileList={fileList}
                  name="profileImage"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {fileList.length > 0 ? (
                    <img
                      src={URL.createObjectURL(fileList[0].originFileObj)}
                      alt="avatar"
                      className="w-20 h-20 rounded-md object-cover"
                    />
                  ) : user?.profileImage ? (
                    <img
                      src={user.profileImage}
                      alt="avatar"
                      className="w-20 h-20 rounded-md object-cover"
                    />
                  ) : (
                    <Avatar shape="square" size={80} className="uppercase text-white">
                      {user?.firstName?.charAt(0)}
                      {user?.lastName?.charAt(0)}
                    </Avatar>
                  )}
                </Upload>
              </ImgCrop>
            </Form.Item>
            <div>
              <ImgCrop rotationSlider showGrid>
                <Upload
                  fileList={fileList}
                  name="profileImage"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  <button
                    type="button"
                    className="bg-primary text-white px-4 py-2 rounded"
                  >
                    Upload new photo
                  </button>
                </Upload>
              </ImgCrop>
              <p className="text-xs text-gray-500 mt-1">
                Allowed JPG, JPEG or PNG. Max size of 800KB
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex gap-2">
              <div className="w-full">
                <label className="text-sm text-[#2F2B3DCC] font-medium">First Name</label>
                <Form.Item name="FirstName" rules={[{ required: true, message: "Please enter first name." }]}>
                  <Input placeholder="First name" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>

              <div className="w-full">
                <label className="text-sm text-[#2F2B3DCC] font-medium">Last Name</label>
                <Form.Item name="LastName" rules={[{ required: true, message: "Please enter last name." }]}>
                  <Input placeholder="Last name" className="mt-1 w-full py-2" />
                </Form.Item>
              </div>
            </div>
            <div>
              <label className="text-sm text-[#2F2B3DCC] font-medium">Phone No.</label>
              <Form.Item name="PhoneNo" rules={[{ required: true, message: "Please enter valid phone number." }]}>
                <Input type="number" placeholder="Phone no." className="mt-1 w-full py-2" />
              </Form.Item>
            </div>

            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Date Of Birth</label>
              <Form.Item name="DOB">
                <DatePicker
                  placeholder="Date of birth"
                  className="mt-1 w-full py-2"
                  format='MM/DD/YYYY'
                />
              </Form.Item>
            </div>

            <div>
              <label className="text-sm text-[#2F2B3DCC] font-medium">City</label>
              <Form.Item name="City" >
                <Input placeholder="City" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>

            <div>
              <label className="text-sm text-[#2F2B3DCC] font-medium">Experience As IB</label>
              <Form.Item name="ExpAsIb">
                <Input type="number" placeholder="Experience as ib" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>

            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Country</label>
              <Form.Item name="CountryOfBirth">
                <Select showSearch placeholder="Select a country" className="w-full mt-1" filterOption={filterOption} options={countries} />
              </Form.Item>
            </div>

          </div>

          <div className="mt-6 flex gap-4">
            <LoadableButton
              type="submit"
              className="bg-primary text-sm text-white font-medium px-6 py-2 rounded-lg themeHover duration-500"
              lable="Save changes"
              loadingLable="Saving..."
              isLoading={isLoadingProfileUpdate}
              disabled={isLoadingProfileUpdate}
            />
          </div>
        </Form >
      </div >

      <div className="mt-5">
        <BankDetails onFinish={handleBankSubmit} isLoading={isLoadingBankDetails} form={bankForm} />
      </div>

      <div className="grid xl:grid-cols-2 xl:gap-5">
        <Form autoComplete="off" onFinish={handleSubmit} form={form} className="mt-5">
          <div className="md:p-6 p-4 border-2 border-light rounded-[10px] h-full">
            <div className="mb-6">
              <p className="text-[#2F2B3D] text-xl font-semibold">Change Password</p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div>
                <p className="mb-1 text-sm">Current Password</p>
                <Form.Item
                  name="oldPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your current password!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Current Password"
                    prefix={<Lock />}
                  />
                </Form.Item>
              </div>
              <div></div>
              <div>
                <p className="mb-1 text-sm">New Password</p>
                <Form.Item
                  name="newPassword"
                  hasFeedback
                  rules={[
                    { required: true, message: "Please input your new password!" },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        if (value.length < 8) {
                          return Promise.reject(new Error("Password must be at least 8 characters long."));
                        }
                        if (!/[a-z]/.test(value)) {
                          return Promise.reject(new Error("Password must contain at least one lowercase letter."));
                        }
                        if (!/[A-Z]/.test(value)) {
                          return Promise.reject(new Error("Password must contain at least one uppercase letter."));
                        }
                        if (!/\d/.test(value)) {
                          return Promise.reject(new Error("Password must contain at least one number."));
                        }
                        if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\];'/`~]/.test(value)) {
                          return Promise.reject(new Error("Password must contain at least one special character."));
                        }
                        return Promise.resolve();
                      }
                    }
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="New Password"
                    prefix={<Lock />}
                  />
                </Form.Item>
              </div>

              <div>
                <p className="mb-1 text-sm">Confirm Password</p>
                <Form.Item
                  dependencies={['newPassword']}
                  hasFeedback
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your new password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('The new password that you entered do not match!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Confirm Password"
                    prefix={<Lock />}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="text-base text-gray-600 mb-6">
              <p className="text-[#2F2B3D] text-lg font-semibold mb-3">Password Requirements:</p>
              <ul className="list-disc pl-5 space-y-3 text-sm">
                <li>Minimum 8 characters long - the more, the better</li>
                <li>At least one lowercase character and uppercase character</li>
                <li>At least one number and one special character</li>
              </ul>
            </div>

            <div className="mt-6 flex gap-4">
              <LoadableButton
                type="submit"
                className="bg-primary text-sm text-white font-medium px-6 py-2 rounded-lg themeHover duration-500"
                lable="Save changes"
                loadingLable="Updating..."
                isLoading={isLoading}
                disabled={isLoading}
              />
            </div>
          </div>
        </Form>

        <div className="md:p-6 p-4 border-2 border-light rounded-[10px] mt-5">
          <p className="text-[#2F2B3D] text-xl font-semibold mb-6">Two-steps verification</p>
          <h4 className="text-base text-gray-500 mb-4">Two factor authentication is not enabled yet.</h4>
          <p className="text-sm text-gray-500">Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in. <span className="primary font-bold">Learn more.</span></p>
          <LoadableButton
            type="button"

            className={`${verifyWithOpt ? 'bg-gradient-red hover:bg-red-600' : 'bg-primary themeHover'} text-sm text-white font-medium px-6 py-2 rounded-lg duration-500 mt-6`}
            lable={verifyWithOpt ? "Disable Two-Factor Authentication" : "Enable Two-Factor Authentication"}
            loadingLable={verifyWithOpt ? "Two-Factor Authentication Disabling..." : "Two-Factor Authentication Enabling..."}
            onClick={open2FAHandle}
            isLoading={loading}
            disabled={loading}
          />
        </div>
      </div>

      <ModalComponent isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} title='Two Factor Authentication' width={600}>
        <div className='sm:grid grid-cols-12 justify-center items-center '>
          <div className='md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center px-10 py-10 gap-6  w-full'>

            <div className="text-center">
              <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                A verification code has been sent to your email address: {userDetails?.email}
              </p>
              <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                Please enter the OTP and verify yourself
              </p>
            </div>
            <div className="w-full">
              <Form autoComplete="off" form={formotp} onFinish={handleSubmit2FA}>
                <div className="w-full text-sm py-1">
                  <div className="relative">
                    <Form.Item
                      name="otp"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Input.OTP
                        {...sharedProps}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="my-6 flex justify-center">
                  {
                    timer == 0 ? (<button type="button" onClick={open2FAHandle} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                  }
                </div>
                <div className="mt-8">
                  <LoadableButton
                    type='submit'
                    className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text'
                    lable='Verify'
                    isLoading={isLoading}
                    loadingLable='Verifying...'
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </ModalComponent>

    </>
  );
}
